import styled from 'styled-components';

export const Container = styled.div`
  padding: 24px 20px;
`;

export const Title = styled.h1`
  font-size: 28px;
  font-weight: 700;
  color: ${props => props.theme.colors.new_primary[500]};
  margin-bottom: 8px;
  line-height: 1.2;
`;

export const Subtitle = styled.p`
  font-size: 14px;
  color: ${props => props.theme.colors.neutral[600]};
  margin-bottom: 24px;
  line-height: 1.4;
`;

export const Form = styled.form``;

export const InfoBanner = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background: ${props => props.theme.colors.new_primary[50]};
  border-radius: 8px;
  padding: 14px 16px;
  margin-top: 8px;
  margin-bottom: 24px;
`;

export const InfoIcon = styled.span`
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: ${props => props.theme.colors.new_primary[500]};
  color: ${props => props.theme.colors.neutral.white};
  font-size: 12px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const InfoText = styled.p`
  font-size: 13px;
  color: ${props => props.theme.colors.neutral[700]};
  line-height: 1.4;
`;

export const SubmitButton = styled.button`
  display: block;
  width: 100%;
  height: 50px;
  border: none;
  border-radius: 25px;
  font-size: 16px;
  font-weight: 600;
  color: ${props => props.theme.colors.neutral.white};
  cursor: ${(props) => props.disabled ? 'not-allowed' : 'pointer'};
  background: ${(props) => props.disabled ? props.theme.colors.neutral[200] : props.theme.colors.new_primary[500]};
  transition: background 0.2s;

  &:hover:not(:disabled) {
    background: ${props => props.theme.colors.new_primary[600]};
  }
`;

export const TermsText = styled.p`
  text-align: center;
  font-size: 12px;
  color: ${props => props.theme.colors.neutral[500]};
  margin-top: 16px;
`;

export const TermsLink = styled.a`
  color: ${props => props.theme.colors.new_primary[500]};
  text-decoration: underline;
`;
